
import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-product-list-toolbar',
  components: ServiceContainer().getComponents(),
})
export default class extends Vue {
  @Prop({required: false}) readonly blockId: number;
  @Prop({required: true}) readonly dataSource: string;
  @Prop({default: 'top'}) readonly type: string;
  @Prop({default: () => []}) private pageSizes: Array<object>;

  private get totalProductCount(): number {
    return this.$store.getters[`${this.dataSource}/totalItemCount`];
  }

  private get currentPage(): number {
    return this.$store.getters[`${this.dataSource}/currentPage`];
  }

  private get pageSize(): number {
    return this.$store.getters[`${this.dataSource}/pageSize`];
  }

  private get pageProductCount(): string {
    const fromProducts = this.currentPage > 1 ? (((this.pageSize * this.currentPage) + 1) - this.pageSize) : 1;
    const toProducts = (this.pageSize * this.currentPage) > this.totalProductCount ? this.totalProductCount : (this.pageSize * this.currentPage);
    return `${fromProducts}-${toProducts} ${this.$t('category-of')} ${this.totalProductCount}`;
  }

  private mounted(): void {
    const placeholder = document.getElementById('toolbarPlaceholder');
    if (placeholder) {
      placeholder.style.visibility = 'hidden';
    }
  }
}
